<!--
=========================================================
* Vue Argon Dashboard 2 - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard-laravel
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <!-- Sin g-sidenav-* aquí: el slider lo controla #app (index.html) como en LBP -->
    <div class="layout-root" :class="{ 'main-with-sidenav': this.$store.state.showSidenav }">
    <div v-show="this.$store.state.layout === 'landing'"
      class="landing-bg h-100 bg-gradient-primary position-fixed w-100 landing-bg-no-events"></div>
    <sidenav :custom_class="this.$store.state.mcolor" :class="[
      this.$store.state.isTransparent,
      this.$store.state.isRTL ? 'fixed-end' : 'fixed-start'
    ]" v-if="this.$store.state.showSidenav" />
    <main class="main-content main-content-with-footer position-relative border-radius-lg d-flex flex-column min-h-0">
    <!-- nav -->
    <navbar :class="[navClasses]" :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : 'text-white'
      " :minNav="navbarMinimize" v-if="this.$store.state.showNavbar" />
    <div class="main-content-scroll" :class="{ 'no-scroll': this.$store.state.showConfig }">
      <router-view v-slot="{ Component, route }">
        <component :is="Component" :key="route.fullPath" v-if="Component" />
      </router-view>
      <app-footer v-show="this.$store.state.showFooter" class="flex-shrink-0" />
    </div>

    <!-- Modulo Categoria -->
    <div class="modal fade" id="ModalCategory" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header flex-wrap align-items-center gap-2">
            <h5 class="modal-title section-title mb-0 me-2">Tiempo perdido</h5>
            <div class="d-flex ms-auto align-items-center gap-2">
              <button type="button" class="btn btn-warning" @click="cancelEditCategory(); openModalCategoryAgregar()">Agregar</button>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
            </div>
          </div>
          <div class="modal-body" v-show="!categoryFormModalOpen">
            <table class="table table-borderless mb-0">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th style="text-align: center; width: 100px;">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="value in categories" :key="value.id">
                  <td>{{ value.fullname }}</td>
                  <td style="text-align: center;">
                    <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editCategory(value)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2"
                      @click="deleteCategory(value.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalCategory">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Ventana Agregar/Editar Categoría -->
    <div class="modal fade" id="ModalCategoryAgregar" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title section-title mb-0">{{ isEditingCategory ? 'Editar Tiempo perdido' : 'Agregar Tiempo perdido' }}</h5>
            <button type="button" class="btn-close" aria-label="Cerrar" @click="closeModalCategoryAgregar"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Categoria</label>
              <input type="text" v-model="category.name" class="form-control" placeholder="Categoria">
            </div>
            <div class="mb-3">
              <label class="form-label">Seleccionar</label>
              <select v-model="category.parent_id" class="form-select">
                <option value="">Seleccionar</option>
                <option v-for="process in parents" :key="process.id" :value="process.id">
                  {{ process.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="onCancelCategoryAgregar">Cancelar</button>
            <button type="button" class="btn btn-warning" @click="submitCategoryAndCloseCategory">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modulo Cuadrilla-->
    <div class="modal fade" id="ModalCrews" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content card modal-cuadrilla">
          <div class="modal-header flex-wrap align-items-center gap-2">
            <h5 class="modal-title section-title mb-0 me-2 text-start">Cuadrilla</h5>
            <div class="d-flex ms-auto align-items-center gap-2">
              <button type="button" class="btn btn-warning" @click="onAgregarCrew">Agregar</button>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
            </div>
          </div>

          <div class="modal-body" v-show="!crewFormModalOpen">
            <table class="table table-cuadrilla">
              <thead>
                <tr>
                  <th style="text-align: left;">Cod. Referencia</th>
                  <th style="text-align: left;">Nombre</th>
                  <th style="text-align: left;">Descripcion</th>
                  <th style="text-align: center;">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="value in crews" :key="value.id">
                  <td style="text-align: left;">{{ value.reference_code }}</td>
                  <td style="text-align: left;">{{ value.name }}</td>
                  <td style="text-align: left;">{{ value.description }}</td>
                  <td class="text-center">
                    <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editCrew(value)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2"
                      @click="deleteCrew(value.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>

                </tr>
              </tbody>
            </table>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalCrews">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Ventana Agregar/Editar Cuadrilla -->
    <div class="modal fade" id="ModalCrewAgregar" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title section-title mb-0">{{ isEditing ? 'Editar Cuadrilla' : 'Agregar Cuadrilla' }}</h5>
            <button type="button" class="btn-close" aria-label="Cerrar" @click="closeModalCrewAgregar"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Cod. Referencia</label>
              <input type="text" v-model="crew.reference_code" class="form-control" placeholder="Cod. Referencia">
            </div>
            <div class="mb-3">
              <label class="form-label">Nombre</label>
              <input type="text" v-model="crew.name" class="form-control" placeholder="Nombre">
            </div>
            <div class="mb-3">
              <label class="form-label">Descripción</label>
              <input type="text" v-model="crew.description" class="form-control" placeholder="Descripción">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="onCancelCrewAgregar">Cancelar</button>
            <button type="button" class="btn btn-warning" @click="submitCrewAndClose">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modulo Color -->
    <div class="modal fade" id="ModalColors" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Color</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-4">
                  <input type="text" v-model="color.name" class="form-control" placeholder="Color" />
                </div>
                <div class="col-4">
                  <input type="text" v-model="color.ref" class="form-control" placeholder="Referencia" />
                </div>

                <div class="col-4">
                  <!-- Si NO estás editando, muestra el botón "+" -->
                  <button v-if="!isEditingColor" type="button" class="btn btn-primary" @click="submitColor">
                    +
                  </button>

                  <!-- Si SÍ estás editando, muestra boton de 'editar' y 'cancelar' -->
                  <div v-else>
                    <button type="button" class="btn btn-warning" @click="submitColor">
                      <i class="fa fa-edit fa-xs"></i>
                    </button>
                    <button type="button" class="btn btn-danger" style="margin-left: 5px;" @click="cancelEditColor">
                      <i class="fa fa-times fa-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Listado de colores -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in colors"
              :key="value.id" style="padding: 3px 15px; margin: 2px;">
              <span>{{ value.name }}</span>
              <span>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editColor(value)">
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteColors(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalColors">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modulo Tallas -->
    <div class="modal fade" id="ModalTallas" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Talla</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-8">
                  <input type="text" v-model="sizeList.size" class="form-control" placeholder="Talla">
                </div>
                <!-- Botón: muestra "+" si NO se está editando; si se edita, muestra editar y cancelar -->
                <div class="col-4">
                  <button v-if="!isEditingTalla" type="button" class="btn btn-primary" @click="submitTalla">
                    +
                  </button>
                  <div v-else>
                    <button type="button" class="btn btn-warning" @click="submitTalla">
                      <i class="fa fa-edit fa-xs"></i>
                    </button>
                    <button type="button" class="btn btn-danger" style="margin-left: 5px;" @click="cancelEditTalla">
                      <i class="fa fa-times fa-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Listado de tallas -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in tallas"
              :key="value.id" style="padding: 3px 15px; margin: 2px;">
              <span>{{ value.size }}</span>
              <span>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editTalla(value)">
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteTalla(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalTallas">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modulo Oficio -->
    <div class="modal fade" id="ModalOficios" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header flex-wrap align-items-center gap-2">
            <h5 class="modal-title section-title mb-0 me-2">Oficios</h5>
            <div class="d-flex ms-auto align-items-center gap-2">
              <button type="button" class="btn btn-warning" @click="onAgregarOficio">Agregar</button>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
            </div>
          </div>
          <div class="modal-body" v-show="!oficioFormModalOpen">
            <table class="table table-borderless mb-0 table-oficios">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th style="text-align: center;">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="value in oficios" :key="value.id">
                  <td>{{ value.name }}</td>
                  <td style="text-align: center;">
                    <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editOficio(value)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteOficios(value.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
                <tr v-if="oficios.length === 0">
                  <td colspan="2" class="text-center text-xxs">No hay registros disponibles</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalOficios">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Ventana Agregar/Editar Oficio -->
    <div class="modal fade" id="ModalOficioAgregar" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title section-title mb-0">{{ isEditingOficio ? 'Editar Oficio' : 'Agregar Oficio' }}</h5>
            <button type="button" class="btn-close" aria-label="Cerrar" @click="closeModalOficioAgregar"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Oficio</label>
              <input type="text" v-model="oficio.name" class="form-control" placeholder="Oficio">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="onCancelOficioAgregar">Cancelar</button>
            <button type="button" class="btn btn-warning" @click="submitOficioAndClose">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modulo Bodega -->
    <div class="modal fade" id="ModalBodegas" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg">
        <div class="modal-content card">
          <div class="modal-header flex-wrap align-items-center gap-2">
            <h5 class="modal-title section-title mb-0 me-2">Bodega o Áreas</h5>
            <div class="d-flex ms-auto align-items-center gap-2">
              <button type="button" class="btn btn-warning" @click="openModalBodegaAgregar">Agregar</button>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
            </div>
          </div>

          <div class="modal-body" v-show="!bodegaFormModalOpen">
            <table class="table table-bodegas">
              <thead>
                <tr>
                  <th>COD</th>
                  <th>Nombre</th>
                  <th>Área</th>
                  <th style="text-align: center;">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="value in bodegas" :key="value.id">
                  <td>{{ value.code }}</td>
                  <td>{{ value.name }}</td>
                  <td>
                    <span v-if="value.tipo == '1' || value.tipo == 1">Bodega</span>
                    <span v-else-if="value.tipo == '2' || value.tipo == 2">Horno</span>
                    <span v-else-if="value.tipo == '3' || value.tipo == 3">Área</span>
                    <span v-else-if="value.tipo == '4' || value.tipo == 4">Modulo</span>
                    <span v-else-if="value.tipo == '5' || value.tipo == 5">Patio</span>
                    <span v-else-if="value.tipo == '6' || value.tipo == 6">Averia</span>
                    <span v-else>Desconocido</span>
                  </td>
                  <td style="text-align: center;">
                    <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editBodega(value)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2"
                      @click="deleteBodegas(value.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalBodegas">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Ventana Agregar/Editar Bodega -->
    <div class="modal fade" id="ModalBodegaAgregar" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title section-title mb-0">{{ isEditing ? 'Editar Bodega o Área' : 'Bodega o Área' }}</h5>
            <button type="button" class="btn-close" aria-label="Cerrar" @click="closeModalBodegaAgregar"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Bodega</label>
              <input type="text" v-model="bodega.name" class="form-control" placeholder="Bodega">
            </div>
            <div class="mb-3">
              <label class="form-label">Codigo</label>
              <input type="text" v-model="bodega.code" class="form-control" placeholder="Codigo">
            </div>
            <div class="mb-3">
              <label class="form-label">Área</label>
              <select v-model="bodega.tipo" class="form-control">
                <option disabled value="">Seleccionar Área</option>
                <option value="1">Bodega</option>
                <option value="2">Horno</option>
                <option value="3">Área</option>
                <option value="4">Modulo</option>
                <option value="5">Patio</option>
                <option value="6">Averia</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="onCancelBodegaAgregar">Cancelar</button>
            <button type="button" class="btn btn-warning" @click="submitBodegaAndClose">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modulo Minas -->
    <div class="modal fade" id="ModalMines" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header flex-wrap align-items-center gap-2">
            <h5 class="modal-title section-title mb-0 me-2">Minas</h5>
            <div class="d-flex ms-auto align-items-center gap-2">
              <button type="button" class="btn btn-warning" @click="onAgregarMine">Agregar</button>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
            </div>
          </div>

          <div class="modal-body" v-show="!mineFormModalOpen">
            <table class="table table-borderless mb-0 table-minas">
              <thead>
                <tr>
                  <th>Mina</th>
                  <th>Ubicación</th>
                  <th style="text-align: center;">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="value in mines" :key="value.id">
                  <td>{{ value.name }}</td>
                  <td>{{ value.location }}</td>
                  <td style="text-align: center;">
                    <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editMine(value)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteMines(value.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </td>
                </tr>
                <tr v-if="mines.length === 0">
                  <td colspan="3" class="text-center text-xxs">No hay registros disponibles</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalMines">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Ventana Agregar/Editar Mina -->
    <div class="modal fade" id="ModalMineAgregar" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title section-title mb-0">{{ isEditing ? 'Editar Mina' : 'Agregar Mina' }}</h5>
            <button type="button" class="btn-close" aria-label="Cerrar" @click="closeModalMineAgregar"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Mina</label>
              <input type="text" v-model="mine.name" class="form-control" placeholder="Mina">
            </div>
            <div class="mb-3">
              <label class="form-label">Ubicación</label>
              <input type="text" v-model="mine.location" class="form-control" placeholder="Ubicación">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="onCancelMineAgregar">Cancelar</button>
            <button type="button" class="btn btn-warning" @click="submitMineAndClose">Guardar</button>
          </div>
        </div>
      </div>
    </div>

  </main>

  <configurator
    ref="configurator"
    :toggle="toggleConfigurator"
    :class="[
      this.$store.state.showConfig ? 'show' : '',
      this.$store.state.hideConfigButton ? 'd-none' : ''
    ]"
  />

  </div>
</template>

<style>
/* Footer al final del contenido (no fijo): el main crece con el contenido y hace scroll */
.main-content.main-content-with-footer {
  min-height: 100vh;
}

.no-scroll {
  overflow: hidden !important;
}

html.body-no-scroll,
body.body-no-scroll {
  overflow: hidden !important;
}

/* Evitar que el fondo de landing cubra el sidebar y bloquee clics */
.landing-bg-no-events {
  pointer-events: none !important;
}

/* En responsive el navbar debe quedar por encima del sidenav para que el botón menú sea clickeable y pueda cerrar el menú */
@media (max-width: 1199.98px) {
  #navbarBlur.navbar-main {
    z-index: 1000;
  }
}


/* Título de sección: mismo estilo que en Nómina, Historial de pagos, etc. + línea amarilla */
.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}
.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}
.table-bodegas th:first-child,
.table-bodegas td:first-child {
  padding-left: 0.5rem;
}
.table-minas thead th:nth-child(1),
.table-minas thead th:nth-child(2),
.table-minas tbody td:nth-child(1),
.table-minas tbody td:nth-child(2) {
  text-align: left !important;
  padding-left: 0.75rem !important;
}
.table-oficios thead th:first-child,
.table-oficios tbody td:first-child {
  text-align: left !important;
  padding-left: 0.75rem !important;
}
.modal-cuadrilla .table-cuadrilla thead th:nth-child(1),
.modal-cuadrilla .table-cuadrilla thead th:nth-child(2),
.modal-cuadrilla .table-cuadrilla thead th:nth-child(3),
.modal-cuadrilla .table-cuadrilla tbody td:nth-child(1),
.modal-cuadrilla .table-cuadrilla tbody td:nth-child(2),
.modal-cuadrilla .table-cuadrilla tbody td:nth-child(3) {
  text-align: left !important;
}
.table-cuadrilla th.text-start,
.table-cuadrilla td.text-start {
  text-align: left !important;
}
table.table.table-cuadrilla thead th:first-child,
table.table.table-cuadrilla thead th:nth-child(2),
table.table.table-cuadrilla thead th:nth-child(3),
table.table.table-cuadrilla tbody td:first-child,
table.table.table-cuadrilla tbody td:nth-child(2),
table.table.table-cuadrilla tbody td:nth-child(3) {
  text-align: left !important;
}
/* Mismo padding en th y td para que el inicio del texto coincida con el título */
.table-cuadrilla thead th,
.table-cuadrilla tbody td {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.modal-cuadrilla .modal-header,
.modal-cuadrilla .modal-body {
  padding-left: 1rem;
}
.modal-cuadrilla .modal-title {
  text-align: left;
}
/* Filtros unificados en tarjetas: buscador y fechas con mismo tamaño y posición */
.card-filters-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.card-filters-buscar {
  flex-grow: 1;
  min-width: 280px;
  max-width: 520px;
}
.card-filters-fechas {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 1.5rem;
}
.card-filters-fecha {
  min-width: 220px;
}
.card-filters-fecha .form-control,
.card-filters-buscar .form-control {
  height: 2.25rem;
}
</style>

<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";
import Swal from 'sweetalert2';
import * as bootstrap from 'bootstrap';


export default {
  name: "App",
  data() {
    return {
      category: {
        id: 0,
        name: '',
        parent_id: ''
      },
      bodega: {
        id: 0,
        name: '',
        description: '',
        code: '',
        tipo: '',
        status: 1,
      },
      crew: {
        id: 0,
        name: '',
        reference_code: '',
        description: '',
      },
      color: {
        id: 0,
        name: '',
        ref: ''
      },
      mine: {
        id: 0,
        name: '',
        location: '',
        status: 1,
      },
      oficio: {
        id: 0,
        name: '',
        description: '',
        status: 1,
      },
      sizeList: {
        id: 0,
        size: ''
      },
      categories: [],
      categoryFormModalOpen: false,
      crews: [],
      crewFormModalOpen: false,
      parents: [],
      colors: [],
      oficios: [],
      oficioFormModalOpen: false,
      bodegas: [],
      bodegaFormModalOpen: false,
      tallas: [],
      mines: [],
      mineFormModalOpen: false,
    }
  },
  components: {
    Sidenav,
    Configurator,
    Navbar,
    AppFooter
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    closeModalCategory() {
      this.categoryFormModalOpen = false;
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalCategory(); // Llama al método para cerrar el modal
      }
    },

    //BODEGAS
    async submitBodegaAndClose() {
      await this.submitBodega();
      this.closeModalBodegaAgregar();
    },
    async submitBodega() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("bodegas/save", this.bodega);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getBodegas();
              this.bodega.id = 0;
              this.bodega.name = '';
              this.bodega.description = '';
              this.bodega.code = '';
              this.bodega.price = '';
              this.bodega.tipo = '';
              this.bodega.status = 1;
              this.isEditing = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editBodega(value) {
      this.isEditing = true;
      this.bodega = {
        id: value.id,
        name: value.name,
        description: value.description,
        code: value.code,
        price: value.price,
        tipo: value.tipo,
        status: value.status,
      };
      this.openModalBodegaAgregar();
    },
    async cancelEditBodega() {
      this.isEditing = false;
      this.bodega.id = 0;
      this.bodega.name = '';
      this.bodega.description = '';
      this.bodega.code = '';
      this.bodega.price = '';
      this.bodega.tipo = '';
      this.bodega.status = 1;
    },
    async getBodegas() {
      const response = await this.$store.dispatch("bodegas/getAll");
      this.bodegas = response;
    },
    async deleteBodegas(id) {
      const result = await Swal.fire({
        title: '¿Eliminar registro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      const response = await this.$store.dispatch("bodegas/delete", id);

      console.log(response);
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getBodegas();
      } else {
        console.log(1111111);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    openModalBodegaAgregar() {
      this.bodegaFormModalOpen = true;
      const el = document.getElementById('ModalBodegaAgregar');
      if (!el) return;
      let instance = bootstrap.Modal.getInstance(el);
      if (!instance) instance = new bootstrap.Modal(el);
      instance.show();
    },
    closeModalBodegaAgregar() {
      this.bodegaFormModalOpen = false;
      const el = document.getElementById('ModalBodegaAgregar');
      if (!el) return;
      const instance = bootstrap.Modal.getInstance(el);
      if (instance) instance.hide();
    },
    onCancelBodegaAgregar() {
      this.cancelEditBodega();
      this.closeModalBodegaAgregar();
    },
    closeModalBodegas() {
      this.bodegaFormModalOpen = false;
      // Obtén el elemento del modal
      const modalElement = document.getElementById('ModalBodegas');
      // Obtén la instancia existente o crea una nueva
      let modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (!modalInstance) {
        modalInstance = new bootstrap.Modal(modalElement);
      }
      // Cierra el modal
      modalInstance.hide();

      // Reinicia el formulario y el estado de edición
      this.bodega.id = 0;
      this.bodega.name = '';
      this.bodega.description = '';
      this.bodega.code = '';
      this.bodega.price = '';
      this.bodega.tipo = '';
      this.bodega.status = 1;
      this.isEditing = false;
    },

    //CATEGORIAS
    onAgregarCategory() {
      this.cancelEditCategory();
      this.openModalCategoryAgregar();
    },
    openModalCategoryAgregar() {
      this.categoryFormModalOpen = true;
      const el = document.getElementById('ModalCategoryAgregar');
      if (!el) return;
      let instance = bootstrap.Modal.getInstance(el);
      if (!instance) instance = new bootstrap.Modal(el);
      instance.show();
    },
    closeModalCategoryAgregar() {
      this.categoryFormModalOpen = false;
      const el = document.getElementById('ModalCategoryAgregar');
      if (!el) return;
      const instance = bootstrap.Modal.getInstance(el);
      if (instance) instance.hide();
    },
    onCancelCategoryAgregar() {
      this.cancelEditCategory();
      this.closeModalCategoryAgregar();
    },
    async submitCategoryAndCloseCategory() {
      await this.submitCategory();
      this.closeModalCategoryAgregar();
    },
    async submitCategory() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("categories/save", this.category);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getCategories();
              this.category.id = 0;
              this.category.name = '';
              this.category.parent_id = '';
              this.isEditingCategory = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editCategory(value) {
      this.isEditingCategory = true;
      this.category = {
        id: value.id,
        name: value.name,
        parent_id: value.parent_id,
      };
      this.openModalCategoryAgregar();
    },
    async cancelEditCategory() {
      this.isEditingCategory = false;
      this.category.id = 0;
      this.category.name = '';
      this.category.parent_id = '';
    },
    async getCategories() {
      const response = await this.$store.dispatch("categories/getCategories");
      this.categories = response.data;
      this.categories.sort((a, b) => a.fullname.localeCompare(b.fullname));
      this.parents = this.categories.filter(category => category.parent_id === null);
    },
    async deleteCategory(id) {
      const result = await Swal.fire({
        title: '¿Eliminar registro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      const response = await this.$store.dispatch("categories/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getCategories();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }
    },

    //COLOR
    async submitColor() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("colors/save", this.color);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getColors();
              this.color.id = 0;
              this.color.name = '';
              this.color.ref = '';
              this.isEditingColor = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editColor(value) {
      this.isEditingColor = true;
      this.color = {
        id: value.id,
        name: value.name,
        ref: value.ref,
      };
    },
    async cancelEditColor() {
      this.isEditingColor = false;
      this.color.id = 0;
      this.color.name = '';
      this.color.ref = '';
    },
    async getColors() {
      const response = await this.$store.dispatch("colors/getColors");
      this.colors = response.data;
    },
    async deleteColors(id) {
      const response = await this.$store.dispatch("colors/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getColors();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }
    },
    closeModalColors() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalColors(); // Llama al método para cerrar el modal
      }
    },

    //CUADRILLAS
    async submitCrew() {
      try {
        const response = await this.$store.dispatch("crews/save", this.crew);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getCrews();
              this.crew.id = 0;
              this.crew.name = '';
              this.crew.description = '';
              this.crew.reference_code = '';
              this.isEditing = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    onAgregarCrew() {
      this.cancelEditCrew();
      this.openModalCrewAgregar();
    },
    openModalCrewAgregar() {
      this.crewFormModalOpen = true;
      const el = document.getElementById('ModalCrewAgregar');
      if (!el) return;
      let instance = bootstrap.Modal.getInstance(el);
      if (!instance) instance = new bootstrap.Modal(el);
      instance.show();
    },
    closeModalCrewAgregar() {
      this.crewFormModalOpen = false;
      const el = document.getElementById('ModalCrewAgregar');
      if (!el) return;
      const instance = bootstrap.Modal.getInstance(el);
      if (instance) instance.hide();
    },
    onCancelCrewAgregar() {
      this.cancelEditCrew();
      this.closeModalCrewAgregar();
    },
    async submitCrewAndClose() {
      await this.submitCrew();
      this.closeModalCrewAgregar();
    },
    async editCrew(value) {
      this.isEditing = true;
      this.crew = {
        id: value.id,
        name: value.name,
        description: value.description,
        reference_code: value.reference_code,
      };
      this.openModalCrewAgregar();
    },
    async cancelEditCrew() {
      this.isEditing = false;
      this.crew.id = 0;
      this.crew.name = '';
      this.crew.reference_code = '';
      this.crew.description = '';
    },
    async getCrews() {
      const response = await this.$store.dispatch("crews/getAll");
      this.crews = response;
    },
    async deleteCrew(id) {
      const result = await Swal.fire({
        title: '¿Eliminar registro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      const response = await this.$store.dispatch("crews/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getCrews();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalCrews() {
      this.crewFormModalOpen = false;
      // Obtén el elemento del modal
      const modalElement = document.getElementById('ModalCrews');
      // Obtén la instancia existente o crea una nueva
      let modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (!modalInstance) {
        modalInstance = new bootstrap.Modal(modalElement);
      }
      // Cierra el modal
      modalInstance.hide();

      // Reinicia el formulario y el estado de edición
      this.crew.id = 0;
      this.crew.name = '';
      this.crew.reference_code = '';
      this.crew.description = '';
      this.isEditing = false;
    },

    //Minas
    async submitMine() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("mines/save", this.mine);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getMines();
              this.mine.id = 0;
              this.mine.name = '';
              this.mine.location = '';
              this.mine.status = 1;
              this.isEditing = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    onAgregarMine() {
      this.cancelEditMines();
      this.openModalMineAgregar();
    },
    openModalMineAgregar() {
      this.mineFormModalOpen = true;
      const el = document.getElementById('ModalMineAgregar');
      if (!el) return;
      let instance = bootstrap.Modal.getInstance(el);
      if (!instance) instance = new bootstrap.Modal(el);
      instance.show();
    },
    closeModalMineAgregar() {
      this.mineFormModalOpen = false;
      const el = document.getElementById('ModalMineAgregar');
      if (!el) return;
      const instance = bootstrap.Modal.getInstance(el);
      if (instance) instance.hide();
    },
    onCancelMineAgregar() {
      this.cancelEditMines();
      this.closeModalMineAgregar();
    },
    async submitMineAndClose() {
      await this.submitMine();
      this.closeModalMineAgregar();
    },
    async editMine(value) {
      this.isEditing = true;
      this.mine = {
        id: value.id,
        name: value.name,
        location: value.location,
        status: value.status,
      };
      this.openModalMineAgregar();
    },
    async cancelEditMines() {
      this.isEditing = false;
      this.mine = { id: 0, name: '', location: '', status: 1, };
    },
    async getMines() {
      const response = await this.$store.dispatch("mines/getAll");
      this.mines = response;
    },
    async deleteMines(id) {
      const result = await Swal.fire({
        title: '¿Eliminar registro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      const response = await this.$store.dispatch("mines/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getMines();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalMines() {
      this.mineFormModalOpen = false;
      // Obtén el elemento del modal
      const modalElement = document.getElementById('ModalMines');
      // Obtén la instancia existente o crea una nueva
      let modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (!modalInstance) {
        modalInstance = new bootstrap.Modal(modalElement);
      }
      // Cierra el modal
      modalInstance.hide();

      // Reinicia el formulario y el estado de edición
      this.mines.id = 0;
      this.mines.name = '';
      this.mines.location = '';
      this.mines.status = 1;
      this.isEditing = false;
    },

    //OFICIO
    async submitOficio() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("oficios/save", this.oficio);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getOficios();
              this.oficio.id = 0;
              this.oficio.name = '';
              this.oficio.description = '';
              this.oficio.status = 1;
              this.isEditingOficio = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    onAgregarOficio() {
      this.cancelEditOficio();
      this.openModalOficioAgregar();
    },
    openModalOficioAgregar() {
      this.oficioFormModalOpen = true;
      const el = document.getElementById('ModalOficioAgregar');
      if (!el) return;
      let instance = bootstrap.Modal.getInstance(el);
      if (!instance) instance = new bootstrap.Modal(el);
      instance.show();
    },
    closeModalOficioAgregar() {
      this.oficioFormModalOpen = false;
      const el = document.getElementById('ModalOficioAgregar');
      if (!el) return;
      const instance = bootstrap.Modal.getInstance(el);
      if (instance) instance.hide();
    },
    onCancelOficioAgregar() {
      this.cancelEditOficio();
      this.closeModalOficioAgregar();
    },
    async submitOficioAndClose() {
      await this.submitOficio();
      this.closeModalOficioAgregar();
    },
    async editOficio(value) {
      this.isEditingOficio = true;
      this.oficio = {
        id: value.id,
        name: value.name,
        description: value.description,
        status: value.status,
      };
      this.openModalOficioAgregar();
    },
    async getOficios() {
      const response = await this.$store.dispatch("oficios/getOficios");
      this.oficios = response.data;
    },
    async deleteOficios(id) {
      const result = await Swal.fire({
        title: '¿Eliminar registro?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      const response = await this.$store.dispatch("oficios/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getOficios();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalOficios() {
      this.oficioFormModalOpen = false;
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalOficios(); // Llama al método para cerrar el modal
      }
    },
    cancelEditOficio() {
      this.isEditingOficio = false;
      this.oficio = { id: 0, name: '', description: '', status: 1 };
    },

    //TALLA
    async submitTalla() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("tallas/save", this.sizeList);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getTallas();
              this.sizeList.id = 0;
              this.sizeList.size = '';
              this.isEditingTalla = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editTalla(value) {
      this.isEditingTalla = true;
      this.sizeList = {
        id: value.id,
        size: value.size,
      };
    },
    async cancelEditTalla() {
      this.isEditingTalla = false;
      this.sizeList.id = 0;
      this.sizeList.size = '';
    },
    async getTallas() {
      const response = await this.$store.dispatch("tallas/getAll");
      this.tallas = response;
    },
    async deleteTalla(id) {
      const response = await this.$store.dispatch("tallas/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getTallas();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalTallas() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalTallas(); // Llama al método para cerrar el modal
      }
    },
  },
  computed: {
    navClasses() {
      return {
        "position-sticky bg-white left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && !this.$store.state.darkMode,
        "position-sticky bg-default left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && this.$store.state.darkMode,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4": !this.$store.state.isAbsolute
      };
    }
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
  mounted() {
    this.getMines();

    let user = JSON.parse(localStorage.getItem('user'));

    // Verificar si el usuario existe
    if (user) {
      this.getCategories();
      this.getCrews();
      this.getColors();
      this.getOficios();
      this.getBodegas();
      this.getTallas();

    } else {
      console.log("No se encontró un usuario en el localStorage.");
      // Opcional: redirigir al login o mostrar un mensaje
    }
  }
};
</script>
